export default "__VITE_ASSET__CoMgniHM__"